<template>
  <b-row class="news-row">
    <b-col xs="10" class="d-flex">
      <a href="/news" class="text-left mt-2 mb-5 news-title">Legfrissebb híreink</a>
    </b-col>
    <b-col xs="2" class="text-right newspager">
      <chevron-left-icon @click="newsPager(-1)" :size="72" v-if="currentPage != 0" />
      <chevron-right-icon
        @click="newsPager(1)"
        :size="72"
        v-if="currentPage * currentLimit <= totalCount - this.currentLimit || currentPage == 0"
      />
    </b-col>
    <b-col cols="12">
      <transition name="fade">
        <b-card-group v-if="showAnim">
          <b-col class="text-left" sm="12" md="12" lg="6" xl="4" v-for="news in visibleNews" :key="news._id">
            <b-card
              :title="news.name"
              :img-src="news.image"
              :img-alt="news.name"
              img-top
              tag="article"
              class="mb-2"
              @click="handleNewsClick(news.seq)"
            >
              <small>{{ newsDate(news.releaseDate) }}</small>
              <b-card-text class="text-justify mt-3">
                {{ news.lead }}
              </b-card-text>
            </b-card>
          </b-col>
        </b-card-group>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'
import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft.vue'

export default {
  name: 'News',
  components: {
    ChevronRightIcon,
    ChevronLeftIcon
  },
  data() {
    return {
      visibleNews: [],
      currentPage: 0,
      showAnim: false,
      totalCount: 0,
      currentLimit: 3
    }
  },
  methods: {
    handleNewsClick(id) {
      this.$router.push(`/news/details/${id}`)
    },
    newsPager(dir) {
      if (dir == 1) {
        this.currentPage++
      } else {
        if (this.currentPage != 0) this.currentPage--
      }
    },
    newsDate(date) {
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      return new Date(date).toLocaleDateString('hu-HU', options)
    }
  },
  async created() {
    const initialNews = await this.$store.dispatch('fetchNews', { page: this.currentPage, limit: this.currentLimit })
    this.visibleNews = initialNews.items
    this.totalCount = initialNews.totalCount
    this.showAnim = true
  },
  watch: {
    async currentPage() {
      this.showAnim = false
      const newsUpdate = await this.$store.dispatch('fetchNews', { page: this.currentPage, limit: this.currentLimit })
      this.visibleNews = newsUpdate.items
      this.totalCount = newsUpdate.totalCount
      this.showAnim = true
    }
  }
}
</script>

<style scoped>
.newspager svg {
  fill: var(--color-green);
  cursor: pointer;
}

.card {
  max-width: 100% !important;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.card-title {
  color: var(--color-body);
  font-weight: 700;
  text-decoration: underline;
}

.card-title:hover {
  cursor: pointer;
}

.card-img-top {
  border-radius: calc(1.25rem - 10px);
}

.card-body {
  padding: 0;
  padding-top: 1.25rem;
}

.chevron-right-icon,
.chevron-left-icon {
  cursor: pointer;
}

.news-row {
  min-height: 600px;
}

.news-title {
  font-size: 32px;
  font-weight: 400;
  color: var(--color-body);
}
</style>
